import BaseInterface from '../baseInterface';

export default class PlayerUIInterface extends BaseInterface {

  handleModelChange({ tournamentsInfo }) {
    const hasActiveTournaments = tournamentsInfo && tournamentsInfo.active && Boolean(tournamentsInfo.active.length);
    const hasFutureTournaments = tournamentsInfo && tournamentsInfo.future && tournamentsInfo.future.some(details => !!details.showAnnouncement);
    const controllerTournamentLabel = this.controllers[this.controllerTypes.ECT_TOURNAMENTS_LABEL];

    if (hasActiveTournaments || hasFutureTournaments) {
      controllerTournamentLabel.show();
    } else {
      controllerTournamentLabel.hide();
    }
  }

  setWinLineConfig(winLineConfig) {
    this._showDeprecationWarning();
  }

  showWinLine(winLineData) {
    this._showDeprecationWarning();
  }

  hideWinLine(winLineData) {
    this._showDeprecationWarning();
  }

  setAvailableBets(bets) {
    const betsController = this.controllers[this.controllerTypes.ECT_BET];
    if (betsController) betsController.setBets(bets);

    const betsTableController = this.controllers[this.controllerTypes.ECT_BET_SELECTOR_TABLE];
    if (betsTableController) {
      betsTableController.setBets(bets);

      const maxBetIndex = betsTableController.maxIndex;
      this.setRecentBets([0, Math.floor(maxBetIndex / 2), maxBetIndex]);
    }
  }

  setRecentBets(recentBets) {
    const betsTableController = this.controllers[this.controllerTypes.ECT_BET_SELECTOR_TABLE];
    if (betsTableController) betsTableController.setRecentBets(recentBets)
  }

  setCurrentBetIndex(betIndex) {
    const betsController = this.controllers[this.controllerTypes.ECT_BET];
    if (betsController) betsController.setCurrentBetIndex(betIndex);

    const betsTableController = this.controllers[this.controllerTypes.ECT_BET_SELECTOR_TABLE];
    if (betsTableController) betsTableController.setCurrentBetIndex(betIndex)
  }

  setBalance(value) {
    const serverBalance = window.OPWrapperService.model.data.serverResponses[window.OPWrapperService.model.data.serverResponses.length - 1].balance;
    if (value > serverBalance) {
      value = serverBalance;
      console.warn('Trying to set balance greater than server balance. Set balance to server balance');
    }

    const balanceController = this.controllers[this.controllerTypes.ECT_BALANCE];
    if (balanceController) balanceController.setValue(value);
    window.OPWrapperService.SystemUI.updateBalanceInfo(value);
  }

  setLastWin(value) {
    const winController = this.controllers[this.controllerTypes.ECT_WIN];
    if (winController) {
      winController.lastWin = value;
    }
  }

  setWin(value) {
    const serverResponse = window.OPWrapperService.model.data.serverResponses[window.OPWrapperService.model.data.serverResponses.length - 1];
    const winLimit = serverResponse && serverResponse.isWinLimitReached ? serverResponse.winLimit : null;
    if (winLimit && value > winLimit) {
      value = winLimit;
      console.warn('Win limit reached. Set win to win limit');
    }

    const winController = this.controllers[this.controllerTypes.ECT_WIN];
    if (winController) {
      winController.setValue(value);
    }
  }

  setWinValue(value) {
    const serverResponse = window.OPWrapperService.model.data.serverResponses[window.OPWrapperService.model.data.serverResponses.length - 1];
    const winLimit = serverResponse && serverResponse.isWinLimitReached ? serverResponse.winLimit : null;
    if (winLimit && value > winLimit) {
      value = winLimit;
      console.warn('Win limit reached. Set win to win limit');
    }

    const winController = this.controllers[this.controllerTypes.ECT_WIN];
    if (winController) {
      winController.setWinValue(value);
    }
  }

  setLabel(value) {
    this._showDeprecationWarning();
  }

  showAutoPlayCount() {
    this._showDeprecationWarning();
  }

  hideAutoPlayCount() {
    this._showDeprecationWarning();
  }

  showTotalWin(value) {
    const winController = this.controllers[this.controllerTypes.ECT_WIN];
    if (winController) {
      winController.showTotalWin(value);
    }
  }

  hideTotalWin() {
    const winController = this.controllers[this.controllerTypes.ECT_WIN];
    if (winController) {
      winController.hideTotalWin();
    }
  }

  setTotalWin(value) {
    const winController = this.controllers[this.controllerTypes.ECT_WIN];
    if (winController) {
      winController.showTotalWin(value);
    }
  }

  showFreeSpins(count, text) {
    const spinController = this.controllers[this.controllerTypes.ECT_SPIN];
    this._Controller._lastFreespinsInfo = { count, text };
    if (spinController) spinController.showFreespins(count, text);
  }

  hideFreeSpinsLabel() {
    this._showDeprecationWarning();
  }

  hideFreeSpins() {
    const spinController = this.controllers[this.controllerTypes.ECT_SPIN];
    this._Controller._lastFreespinsInfo = null;
    if (spinController) spinController.hideFreespins();
  }

  setFreeSpinsCount(count) {
    const spinController = this.controllers[this.controllerTypes.ECT_SPIN];
    this._Controller._lastFreespinsInfo = { ...this._Controller._lastFreespinsInfo, count };
    if (spinController) spinController.freespinsCount = count;
  }

  toggleSpinButton(enabled) {
    const spinController = this.controllers[this.controllerTypes.ECT_SPIN];
    if (!spinController) return;

    if (enabled) {
      spinController.unblock(spinController.buttonsTypes.EBT_SPIN);
    } else {
      spinController.block(spinController.buttonsTypes.EBT_SPIN);
    }
  }

  toggleStopButton(enabled) {
    this._showDeprecationWarning();
  }

  toggleAutoPlayButton(enabled) {
    const autoPlayController = this.controllers[this.controllerTypes.ECT_AUTO_SPIN];
    if (!autoPlayController) return;

    if (enabled) {
      autoPlayController.unblock();
    } else {
      autoPlayController.block();
    }
  }

  toggleTurboPlayButton(enabled) {
    const turboPlayController = this.controllers[this.controllerTypes.ECT_TURBO_SPIN];
    if (!turboPlayController) return;

    if (enabled) {
      turboPlayController.unblock();
    } else {
      turboPlayController.block();
    }
  }

  toggleMenuButton(enabled) {
    const menuController = this.controllers[this.controllerTypes.ECT_MENU];
    if (!menuController) return;

    if (enabled) {
      menuController.unblock();
    } else {
      menuController.block();
    }
  }

  toggleInfoButton(enabled) {
    const infoController = this.controllers[this.controllerTypes.ECT_INFO];
    if (!infoController) return;

    if (enabled) {
      infoController.unblock();
    } else {
      infoController.block();
    }
  }

  toggleTournamentsLabel(enabled) {
    const tournamentsLabelController = this.controllers[this.controllerTypes.ECT_TOURNAMENTS_LABEL];

    if (enabled) {
      tournamentsLabelController.unblock();
    } else {
      tournamentsLabelController.block();
    }
  }

  toggleBetSelectors(enabled) {
    const betController = this.controllers[this.controllerTypes.ECT_BET];
    const betSelectController = this.controllers[this.controllerTypes.ECT_BET_SELECT];
    const betSelectorTableController = this.controllers[this.controllerTypes.ECT_BET_SELECTOR_TABLE];
    [betController, betSelectController, betSelectorTableController].forEach(controller => {
      if (!controller) return;

      if (enabled) {
        controller.unblock();
      } else {
        controller.block();
      }
    });
  }

  showSpinButton() {
    this._showDeprecationWarning();
  }

  runSpinAnimation() {
    const spinController = this.controllers[this.controllerTypes.ECT_SPIN];
    spinController.runSpinAnimation();
  }

  showTournamentsLabel() {
    const tournamentsLabelController = this.controllers[this.controllerTypes.ECT_TOURNAMENTS_LABEL];
    if (tournamentsLabelController) tournamentsLabelController.show();
  }

  hideTournamentsLabel() {
    const tournamentsLabelController = this.controllers[this.controllerTypes.ECT_TOURNAMENTS_LABEL];
    if (tournamentsLabelController) tournamentsLabelController.hide();
  }

  showStopButton() {
    this._showDeprecationWarning();
  }

  setAutoPlayButtonActive(value) {
    const autoPlayController = this.controllers[this.controllerTypes.ECT_AUTO_SPIN];
    if (autoPlayController) autoPlayController.toggleActive(value);
  }

  setTurboPlayButtonActive(value) {
    const turboPlayController = this.controllers[this.controllerTypes.ECT_TURBO_SPIN];
    if (turboPlayController) turboPlayController.toggleActive(value);
  }

  setSoundMuted(value) {
    const soundController = this.controllers[this.controllerTypes.ECT_SOUND];
    if (soundController) soundController.setMuted(value);
  };

  tryActiveAutoPlay() {
    const autoPlayTableController = this.controllers[this.controllerTypes.ECT_AUTO_PLAY_TABLE];
    if (autoPlayTableController) {
      autoPlayTableController.tryActiveAutoPlay();
    }
  }

  hideAutoPlayTable() {
    const autoPlayTableController = this.controllers[this.controllerTypes.ECT_AUTO_PLAY_TABLE];
    if (autoPlayTableController) autoPlayTableController.hide();
  }

  showFreeBetsPanel() {
    const freebetsController = this.controllers[this.controllerTypes.ECT_FREEBETS_PANEL];
    if (freebetsController) {
      freebetsController.show();
      this._Controller.scaleData = window.OPWrapperService.ScaleManager.currentData;
    }
  }

  setFreeBets(value) {
    const freebetsController = this.controllers[this.controllerTypes.ECT_FREEBETS_PANEL];
    if (freebetsController) freebetsController.setFreeBets(value);
  }

  updateFreeBets(data) {
    const freebetsController = this.controllers[this.controllerTypes.ECT_FREEBETS_PANEL];
    if (freebetsController) freebetsController.update(data);
  }

  setFreeBetsBet(data) {
    const freebetsController = this.controllers[this.controllerTypes.ECT_FREEBETS_PANEL];
    if (freebetsController) freebetsController.setBet(data);
  }

  setFreeBetsTotalWin(value) {
    const freebetsController = this.controllers[this.controllerTypes.ECT_FREEBETS_PANEL];
    if (freebetsController) freebetsController.setTotalWin(value);
  }

  hideFreeBetsPanel() {
    const freebetsController = this.controllers[this.controllerTypes.ECT_FREEBETS_PANEL];
    if (freebetsController) {
      freebetsController.hide();
      this._Controller.scaleData = window.OPWrapperService.ScaleManager.currentData;
    }
  }

  closePopups() {
    this._Controller.hideOverlay();
    const betsTableController = this.controllers[this.controllerTypes.ECT_BET_SELECTOR_TABLE];
    const autoPlayTableController = this.controllers[this.controllerTypes.ECT_AUTO_PLAY_TABLE];
    const betsSelectController = this.controllers[this.controllerTypes.ECT_BET_SELECT];
    const autoSpinController = this.controllers[this.controllerTypes.ECT_AUTO_SPIN];
    // const honestyController = this.controllers[this.controllerTypes.ECT_HONESTY];
    if (betsTableController) betsTableController.hide();
    if (autoPlayTableController) autoPlayTableController.hide();
    if (betsSelectController) betsSelectController.reset();
    if (autoSpinController) autoSpinController.toggleActive(window.OPWrapperService.autoPlay.active);
    // if (honestyController) honestyController.hide();
  }

  hideTopMainTextsControllers() {
    this._showDeprecationWarning();
  }

  hideBottomMainTextsControllers() {
    this._showDeprecationWarning();
  }

  get spinButtonEnabled() {
    const spinController = this.controllers[this.controllerTypes.ECT_SPIN];
    return spinController && !spinController.isBlocked(spinController.buttonsTypes.EBT_SPIN);
  }

  get stopButtonEnabled() {
    this._showDeprecationWarning();
  }

  get tournamentLabelEnabled() {
    const controllerTournamentLabel = this.controllers[this.controllerTypes.ECT_TOURNAMENTS_LABEL];
    return controllerTournamentLabel && !controllerTournamentLabel.isHidden && !controllerTournamentLabel.isBlocked(controllerTournamentLabel.buttonsTypes.EBT_BUTTON_LABEL);
  }

  get topMainTextsControllers() {
    this._showDeprecationWarning();
  }

  get bottomMainTextsControllers() {
    this._showDeprecationWarning();
  }

  get eLabelsTypes() {
    this._showDeprecationWarning();
  }

  _showDeprecationWarning() {
    console.warn('Method is deprecated');
  }
}
